import { api } from 'api/axios';
import strings from 'constants/strings';
import { NotificationMessage } from 'model/notification';
import qs from 'qs';
import { useQuery } from 'react-query';
import { DEFAULT_REFRESH_INTERVAL } from 'utils/config';

export async function listMessage(query: {
  familyId?: string;
  read?: boolean;
  page?: number;
  pageSize?: number;
}) {
  query.page = query.page || 0;
  query.pageSize = query.pageSize || 10;
  let url = `/notification/message`;
  const queryString = qs.stringify(query);
  if (queryString) {
    url += `?${queryString}&type=medicalcare,medicine_delivery`;
  }
  const response = await api.get(url);
  return response.data;
}

function normalize(message: NotificationMessage): NotificationMessage {
  // handle voip message
  if (message.extraInfo && message.extraInfo.type === 'voip') {
    message.notificationText = message.extraInfo.answered
      ? strings.notification.answered
      : strings.notification.not_answered;
  }
  return message;
}

export const useNotificationList = (query: {
  familyId?: string;
  userId?: string;
  page?: number;
  pageSize?: number;
}) => {
  const { data, ...rest } = useQuery<
    unknown,
    unknown,
    {
      items: NotificationMessage[];
      total: number;
      page: number;
      pageSize: number;
    }
  >(['notification', query], () => listMessage(query), {
    enabled: !!query.userId,
    staleTime: 0,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchInterval: DEFAULT_REFRESH_INTERVAL,
  });
  return {
    notificationList: data?.items,
    ...rest,
  };
};
